(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_auto-tabs"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  const $wrap = $('.top_auto-tabs');
  const $tabs = $wrap.find('.tab-btn');
  const $contents = $wrap.find('.tab-content');
  let cur = 0, timer;

  // ローディング解除
  $wrap.removeClass('loading');

  // 全て非表示
  $contents.hide();
  // 最初だけ表示
  $contents.eq(0).fadeIn(200);
  $tabs.eq(0).addClass('active');

  function show(i){
    if(i === cur) return;

    // 先に fadeOut → 終わったら fadeIn
    $contents.eq(cur).stop(true,true).fadeOut(300, function(){
      $contents.eq(i).stop(true,true).fadeIn(300);
    });

    // タブのactive切り替え
    $tabs.removeClass('active').eq(i).addClass('active');

    cur = i;
  }

  function start(){
    timer = setInterval(()=>{
      show((cur+1) % $tabs.length);
    }, 4000);
  }

  function stop(){
    clearInterval(timer);
  }

  // タブクリック
  $tabs.on('click', function(){
    show($(this).index());
  });

  // タブ & コンテンツ に触ったら停止
  $tabs.add($contents).on('mouseenter', stop).on('mouseleave', start);

  // 自動再生開始
  start();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
    $('.top_content-slider').slick({
        arrows: false,
        autoplay: true,
        centerMode: true,
        centerPadding: "25%",
        dots: true,

        responsive: [{
        breakpoint: 768, // 768px以下の画面幅で適用
            settings: {
                centerPadding: "10%",
            }
        }]
    });
});

  } catch(e) { console.error(e); }
})();
})();
